module.exports = __webpack_public_path__ + "static/media/7-2.b5935a41.mp3";